import { Model } from 'app/model/backendmodel';
import { IAttribute } from 'app/model/base/annotation';
import { Constants } from 'app/shared/shared-constants';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { ModelUtilties } from 'app/model/services/model-utilities';
import {
    AdapterContext,
    DefaultIdentityProvider,
    ILogger,
    IResourceContext,
    linkedServiceReferenceToResource as shellLinkedServiceReferenceToResource
} from 'shell-models-lib';
import { ParameterValue } from 'app/model/base/parameter-value';
import { logParseNonObjectAsObjectEventFunc } from 'app/shared/utils/parameter-converter.util';

// try using `valueToResource()` from `linkedservice.adapter.ts` instead. These 2 functions are almost identical
export function connectionStringPartToResource(linkedService: LinkedService, attribute: IAttribute): string {
    let value: string | number | undefined = attribute.templateValue(linkedService);
    value = value != null ? value : attribute.value(linkedService);
    return value ? value.toString() : '';
}

// try using `toModel()` from `value.adapter.ts` instead. These 2 functions are almost identical
// currently only take 2 kinds of things: string or number. currently, number is only used for port
export function connectionStringPartToModel(linkedService: LinkedService, attribute: IAttribute, value: string | undefined, maskCredential?: boolean): void {
    if (value == null) {
        return;
    }
    if (isLogicAppExpression(value)) {
        attribute.setTemplateValue(linkedService, value);
        // Still need to set the value because some metadata uses the value to determine the default value
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (linkedService as any)[attribute.name] = value;
    } else {
        attribute.setValue(linkedService, maskCredential ? Constants.maskedCredential : value);
    }
}


export async function linkedServiceToResourceForQueryAsync(linkedService: LinkedService, contextData: IResourceContext): Promise<Model.LinkedServiceResource> {
    const adapterContext = AdapterContext.newAdapterContext({
        contextData,
        identityProvider: DefaultIdentityProvider.instance,
        usedForQueryApi: true
    });

    return await ModelUtilties.toResource(adapterContext, linkedService) as Model.LinkedServiceResource;
}

export function linkedServiceReferenceToResource(linkedService: LinkedService | undefined, context: AdapterContext, loggerService: ILogger, parameters?: ParameterValue[]): Model.LinkedServiceReference | undefined {
    return shellLinkedServiceReferenceToResource(linkedService, context, parameters, loggerService, logParseNonObjectAsObjectEventFunc);
}
